import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import FlagListingContainer from 'containers/FlagListingContainer';

import { StyledDropdownItem } from './ListingActionsDropdown.styled';
import { ListingActionsDropdownListingType } from './ListingActionsDropdownTypes';

type Props = {
  closeMenu: () => void;
  listing: ListingActionsDropdownListingType;
};

export function ReportListingMenuItem({ closeMenu, listing }: Props) {
  return (
    <FlagListingContainer
      listingId={listing.id}
      listingType={listing.type}
      render={({ flagListing }) => (
        <StyledDropdownItem
          data-qa-id="flag-content"
          onClick={(e) => {
            e.preventDefault();
            flagListing();
            closeMenu();
          }}
        >
          <Box mr="10px">
            <Icon name="flag" size={16} />
          </Box>
          {getText('Report This Listing')}
        </StyledDropdownItem>
      )}
    />
  );
}
